import React, { useEffect, useState } from "react";
import { Button, Card, Col, ListGroup, Nav, ProgressBar, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import Avatar from "../../components/Avatar";
import MedicalRecordsTable from "../../components/tables/medicalRecordsTable";
import ProfileCard from "../../components/dashboard/profileCard";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
export default function AllPatients() {
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        {/* <div className="d-md-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="main-title mb-0">Welcome <span className="fw-bolder">!Faruk</span></h4>
          </div>
          <div className="d-flex gap-2 mt-3 mt-md-0">
           
            <Button variant="" className="btn-white d-flex align-items-center gap-2">
              <i className="ri-printer-line fs-18 lh-1"></i>
            </Button>
            <Button variant="primary" className="d-flex align-items-center gap-2">
              <i className="ri-bar-chart-2-line fs-18 lh-1"></i>Book Appointment<span className="d-none d-sm-inline"></span>
            </Button>
          </div>
        </div> */}

        <Row className="g-3">
          <Col xl="3">
            <ProfileCard/>
          </Col>
          <Col xl="8">
            <Card className="card-one">
          <Nav className="nav-line d-none d-lg-flex mb-4">
              <Nav.Link href="/dashboard/finance" >Profile Overview</Nav.Link>
              <Nav.Link href="" className="active">Medical Records</Nav.Link>
              <Nav.Link href="/dashboard/overview">Lab Examination Results</Nav.Link>
              <Nav.Link href="/dashboard/analytics">Vital History</Nav.Link>
              <Nav.Link href="/dashboard/crypto">Immunization</Nav.Link>
              <Nav.Link href="/bills/Dashboard">Payment & Billing</Nav.Link>
            </Nav>
             
              <Card.Header>
                <Card.Title as="h6">Medical Records</Card.Title>
                <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav>
              </Card.Header>
              <Card.Body className="p-3">
                <MedicalRecordsTable/>
              </Card.Body>
            </Card>
          </Col>
          
     
       
    
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
